<template>
  <div style="padding-bottom: 52px">
    <div class="head-top" v-if="headTab.length>1">
      <div
        class="head-top-btn"
        :class="{'activeTab':active===index,'noActive':active!==index}"
        @click="active=index"
        v-for="(item,index) in headTab"
      >{{item.name}}</div>
    </div>

    <!--扫码添加-->
    <div v-show="active===0" class="content">
      <div class="code-img">
        <img src="../../src/assets/icon-saoma.png" @click="scanQRCode()" />
        <span>扫码获取产品信息</span>
      </div>
      <div class="back-inner">
        <ul class="cont-auto">
          <li>
            <span class="name">产品</span>
            <span
              class="back-text"
            >{{addData.productName&&addData.productName!=""?addData.productName:"示例：苹果"}}</span>
          </li>
          <li>
            <span class="name">品牌</span>
            <span
              class="back-text"
            >{{addData.brandName&&addData.brandName!=""?addData.brandName:"示例：红富士"}}</span>
          </li>
          <li>
            <span class="name">批次</span>
            <span
              class="back-text"
            >{{addData.batchName&&addData.batchName!=""?addData.batchName:"示例：第01批次"}}</span>
          </li>
        </ul>
      </div>
    </div>
    <!--手动添加-->
    <div v-show="active===1" class="content">
      <div class="back-inner">
        <ul class="manual">
          <li>
            <cube-select
              v-model="addData.productId"
              :options="productList"
              title="产品"
              placeholder="请选择产品"
              @change="list_c"
            ></cube-select>
          </li>
          <li>
            <cube-select
              v-model="addData.brandId"
              :options="brandList"
              title="品牌"
              placeholder="请选择品牌"
              @change="list_bc"
            ></cube-select>
          </li>
          <li>
            <cube-select
              v-model="addData.batchId"
              :options="batchList"
              title="批次"
              placeholder="请选择批次"
              @change="list_d"
            ></cube-select>
          </li>
        </ul>
      </div>
    </div>

    <div class="content">
      <div class="other">
        <div class="item">
          <span class="name">数量</span>
          <input type="text" placeholder="请输入单位继承批次溯源记录最小单位" v-model="addData.number" />
        </div>
        <div class="item">
          <span class="name">物流单位</span>
          <input type="text" v-model="addData.logisticsCompany" placeholder="请输入物流公司名称" />
        </div>
        <div class="item">
          <span class="name">采购单位</span>
          <input type="text" v-model="addData.buyCompany" placeholder="请输入采购单位" />
        </div>
      </div>
    </div>

    <div class="content" style="margin-top: 10px;">
      <div class="pic">
        <div class="title">
          <span>上传照片</span>
          <span class="small">请上传物流单、订货单等相关凭证</span>
        </div>
        <div class="list">
          <div
            class="demo-upload-list"
            style="display: inline-block"
            v-for="(item,index) in addData.imgUrl"
          >
            <template>
              <img :src="item.urlShow" />
              <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="clear(index)"></Icon>
              </div>
            </template>
          </div>
          <span v-if="rand<0">{{rand}}</span>
          <div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :on-success="handleSuccess5"
              :before-upload="handleBeforeUpload"
              :format="['jpg','jpeg','png']"
              :max-size="6048"
              :on-exceeded-size="handleMaxSize"
              multiple
              type="drag"
              :headers="{'Authorization':'bearer'+token}"
              :action="httpUrl+'/udload/upload/file'"
              style="display: inline-block;width:58px;"
              accept="image/*"
              capture="camera"
            >
              <div style="width: 58px;height:58px;display:flex;align-items:center;justify-content:center">
                <Icon type="ios-camera" size="20"></Icon>
              </div>
            </Upload>
          </div>
        </div>
      </div>
    </div>

    <div class="submit">
      <cube-button @click="add()">提交</cube-button>
    </div>
  </div>
</template>

<script>
import { addlogistics } from "@/api/bapi";
import { broducts } from "@/api/bapi";
import { brand_list } from "@/api/bapi";
import { batchs } from "@/api/bapi";
export default {
  name: "add-logistics",
  data() {
    return {
      rand: 0,
      token: "",
      userInfo: {},
      productList: [],
      brandList: [],
      batchList: [],
      headTab: [{ name: "扫码添加" }, { name: "手动添加" }],
      active: 0,
      //手动添加设置
      addData: {},
      number: ""
    };
  },
  computed: {
    httpUrl() {
      return this.$store.state.httpUrl;
    }
  },
  watch: {
    $route(to, from) {
      if (/\/Center/gi.test(to.path)) {
        this.addData = {
          imgUrl: [],
          id: 0
        };
        this.getInfo();
        this.getProduct();
      }
    }
  },
  created() {
    this.getInfo();
    this.getProduct();
  },
  methods: {
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "上传失败",
        desc: "图片大小不能超过2M"
      });
    },
    handleBeforeUpload() {
      if (this.addData.imgUrl) {
        const check = this.addData.imgUrl.length < 5;
        if (!check) {
          this.$Notice.warning({
            title: "图片不能多于5张"
          });
        }
        return check;
      } else return true;
    },
    handleView(url) {
      this.imgName = url;
      this.visible = true;
    },
    show() {
      (this.addData = {
        id: 0
      }),
        (this.addMd = !this.addMd);
    },
    errorShow(msg) {
      this.$Message.error(msg);
      setTimeout(() => {
        this.addMd = false;
        this.$nextTick(() => {
          this.addMd = true;
        });
      }, 100);
    },
    clear(index) {
      this.rand++;
      this.addData.imgUrl.splice(index, 1);
    },
    progress(event, file, fileList) {
      // console.log(file);
    },
    handleSuccess5(res, file, fileList) {
      // console.log(fileList);
      // 因为上传过程为实例，这里模拟添加 url
      file.url = this.httpUrl + "/udload/upload/file";
      file.name = "file";
      if (!this.addData.imgUrl) {
        this.addData.imgUrl = [];
      }
      console.log(this.addData);
      if (this.addData.imgUrl.length < 5) {
        this.addData.imgUrl.push({
          id: this.addid,
          url: res.data.pathUrl,
          urlShow: res.data.fullUrl
        });
        this.addid--;
        this.rand++;
      }
    },
    handleRemove(res, file) {
      if (this.addData.imgUrl && this.addData.imgUrl.length > 0) {
        for (let i = 0; i < this.addData.imgUrl.length; i++)
          if (this.addData.imgUrl[i].url == res.response.data) {
            this.addData.imgUrl.splice(i, 1);
          }
      }
    },
    getInfo() {
      this.loginShow = false;
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("MicroMessenger") > 0) {
        this.headTab = [{ name: "扫码添加" }, { name: "手动添加" }];
        this.loginShow = true;

        this.active = 0;
      } else {
        this.headTab = [{ name: "手动添加" }];
        this.active = 1;
      }
      if (localStorage.getItem("loginUserInfo")) {
        this.token = localStorage.getItem("access_token");
        this.userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
      } else {
        this.$Message.error("登陆失效，请重新登录");
        this.$router.push("/login");
      }
    },
    joinBtn(index, path) {
      this.isActive = index;
      // console.log(path)
      // console.log(this.$route.name)
      if (this.$route.name == path) return;
      this.$router.push({ path: path });
    },
    getProductInfo() {
      this.$axios({
        method: "get",
        url: "/portal/suyuan/getProductInfo/" + this.number
      })
        .then(res => {
          if (res.data.code == 0) {
            this.rand++;
            this.addData.productId = res.data.data.productId;
            this.addData.productName = res.data.data.pname;
            this.addData.brandId = res.data.data.brandId;
            this.addData.brandName = res.data.data.brandName;
            this.addData.batchId = res.data.data.batchId;
            if(res.data.data.batchName)
            {
            this.addData.batchName = res.data.data.batchName;
            }
            else
            {
            this.addData.batchName = res.data.data.batchId;
            }
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    scanQRCode() {
      var u = navigator.userAgent;
      let vue = this;
      if (u.indexOf("Mac OS X") > 0 && u.indexOf("MicroMessenger") > 0) {
        wx.scanQRCode({
          // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
          needResult: 1,
          desc: "scanQRCode desc",
          success: function(res) {
            //扫码后获取结果参数赋值给Input
            var url = res.resultStr;
            //商品条形码，取","后面的
            if (url.indexOf(",") >= 0) {
              var tempArray = url.split(",");
              var tempNum = tempArray[1];
              vue.number = tempNum;
            } else {
              vue.number = url;
            }

            if (vue.number.indexOf("=") > 0) {
              vue.number = vue.number.substr(
                vue.number.indexOf("=") + 1,
                vue.number.length - vue.number.indexOf("=") - 1
              );
              vue.getProductInfo();
            } else {
              let list = vue.number.split("/");
              vue
                .$axios({
                  method: "get",
                  url: "portal/suyuanChannel/getNum/" + list[list.length - 1]
                })
                .then(res => {
                  if (res.data.code == 1) {
                    vue.number = res.data.msg;
                    this.getProductInfo();
                  } else {
                    this.errorShow(res.data.msg);
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          }
        });
          wx.error(function(res) {
              alert(JSON.stringify(res));
            });
      } else if (u.indexOf("Mac OS X") < 0 && u.indexOf("MicroMessenger") > 0) {
        let vurl = window.location.href;
        let product = this.product;
        var link = vurl;
        getticket({ url: vurl })
          .then(rsp => {
            let wxconfig = rsp.data.data;
            wx.config({
              debug: false,
              appId: wxconfig.appId,
              timestamp: parseInt(wxconfig.timestamp),
              nonceStr: wxconfig.noncestr,
              signature: wxconfig.signature,
              jsApiList: ["scanQRCode"]
            });
            wx.ready(function() {
              wx.scanQRCode({
                // 默认为0，扫描结果由微信处理，1则直接返回扫描结果
                needResult: 1,
                desc: "scanQRCode desc",
                success: function(res) {
                  //扫码后获取结果参数赋值给Input
                  var url = res.resultStr;
                  //商品条形码，取","后面的
                  if (url.indexOf(",") >= 0) {
                    var tempArray = url.split(",");
                    var tempNum = tempArray[1];
                    vue.number = tempNum;
                  } else {
                    vue.number = url;
                  }
                  if (vue.number.indexOf("=") > 0) {
                    vue.number = vue.number.substr(
                      vue.number.indexOf("=") + 1,
                      vue.number.length - vue.number.indexOf("=") - 1
                    );
                    vue.getProductInfo();
                  } else {
                    let list = vue.number.split("/");
                    vue
                      .$axios({
                        method: "get",
                        url:
                          "portal/suyuanChannel/getNum/" + list[list.length - 1]
                      })
                      .then(res => {
                        if (res.data.code == 1) {
                          vue.number = res.data.msg;
                          this.getProductInfo();
                        } else {
                          this.errorShow(res.data.msg);
                        }
                      })
                      .catch(err => {
                        console.log(err);
                      });
                  }
                }
              });
            });
            wx.error(function(res) {
              alert(JSON.stringify(res));
            });
          })
          .catch(rsp => {
            console.log(rsp);
          });
      }
    },
    add() {
      console.log(this.addData);
      if (!this.addData.id) {
        this.addData.id = 0;
      }
      if (!this.addData.brandId) {
        this.errorShow("请选择品牌");
      } else if (!this.addData.productId || this.addData.productId == "") {
        this.errorShow("请选择产品");
      } else if (!this.addData.batchId) {
        this.errorShow("请选择批次");
      } else if (!this.addData.number || this.addData.number == "") {
        this.errorShow("请输入数量");
      } else if (
        !this.addData.logisticsCompany ||
        this.addData.logisticsCompany == ""
      ) {
        this.errorShow("请输入物流公司名称");
      } else if (
        !this.addData.logisticsCompany ||
        this.addData.logisticsCompany == ""
      ) {
        this.errorShow("请输入采购单位");
      } else if (!this.addData.imgUrl || this.addData.imgUrl.length <= 0) {
        this.errorShow("请上传凭证");
      } else {
        let uer = JSON.stringify(this.addData);
        addlogistics(uer)
          .then(res => {
            if (res.data.code == 0) {
              if (this.addData.id > 0) {
                this.$Message.success("修改成功!");
              } else {
                this.$Message.success("添加成功！");
              }
              this.addData = {};
            } else {
              this.$Message.error(res.data.msg);
            }
          })
          .catch(function(reason) {});
      }
    },

    getBrand() {
      brand_list(this.userInfo.org.orgId)
        .then(res => {
          if (res.status == 200) {
            this.brandList = [];
            res.data.data.records.forEach(o => {
              this.brandList.push({ text: o.bname, value: o.id });
            });
          }
        })
        .catch(function(reason) {
          alert(reason);
        });
    },
    getBrand() {
      brand_list(this.userInfo.org.orgId)
        .then(res => {
          if (res.status == 200) {
            this.brandList = [];
            res.data.data.forEach(o => {
              this.brandList.push({ text: o.bname, value: o.id });
            });
          }
        })
        .catch(function(reason) {
          alert(reason);
        });
    },
    //产品类目
    getbatch() {
      //获取列表
      batchs({
        current: 1,
        size: 1000,
        productId: this.addData.productId
      })
        .then(res => {
          if (res.status == 200) {
            this.batchList = [];
            res.data.data.records.forEach(o => {
              if(!o.batchName)
              {
                o.batchName=o.batchId;
              }
              this.batchList.push({ text: o.batchName, value: o.batchId });
            });
          }
        })
        .catch(function(reason) {
          alert("您暂无权限");
        });
    },

    list_bc(value) {
      console.log(value);
      this.brandList.forEach(o => {
        if (o.value == value) {
          this.addData.brandName = o.text;
        }
      });
    },
    //品牌选择
    list_c(value) {
      console.log(value);
      this.productList.forEach(o => {
        if (o.value == value) {
          this.addData.productName = o.text;
        }
      });
      this.getbatch();
    },
    //品牌选择
    list_d(value) {
      this.batchList.forEach(o => {
        if (o.value == value) {
          this.addData.batchName = o.text;
        }
      });
    },

    getProduct() {
      //获取关联产品列表
      broducts({
        current: 1,
        size: 1000
      })
        .then(res => {
          if (res.status == 200) {
            this.productList = [];
            res.data.data.records.forEach(o => {
              this.productList.push({ text: o.pname, value: o.id });
            });
          }
          this.getBrand();
        })
        .catch(function(reason) {
          alert("网络连接错误!!!");
        });
    }
  }
};
</script>

<style scoped>
.head-top {
  display: flex;
  height: 44px;
  width: 100%;
}
.activeTab {
  color: #4cae4c;
}
.noActive {
  background-color: #ffffff;
}
.head-top-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(50%);
  font-size: 16px;
  background-color: #ffffff;
  border-bottom: 1px solid #f5f5f5;
}
.activeTab:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -10px;
  width: 20px;
  height: 2px;
  background-color: #4cae4c;
}
.content {
  background-color: #fff;
}
.content .code-img {
  padding: 10px 15px;
}
.content .code-img img {
  display: block;
  margin: 0 auto;
  width: 100px;
  height: 100px;
  object-fit: cover;
  object-position: center;
}
.content .code-img span {
  display: block;
  margin: 10px 0;
  font-size: 14px;
  color: #333;
  text-align: center;
}
.content .back-inner {
  background-color: #fff;
}
.content .back-inner .cont-auto {
  padding: 0 15px;
}
.content .back-inner .cont-auto li {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f5f5f5;
}
.content .back-inner .cont-auto li .name {
  font-size: 14px;
  color: #333;
}
.content .back-inner .cont-auto li .back-text {
  flex: 1;
  margin-left: 15px;
  font-size: 14px;
  color: #666;
  text-align: right;
}

.content .back-inner .manual {
  padding: 10px 15px;
}
.content .back-inner .manual li {
  margin-top: 10px;
}
.content .back-inner .manual li:first-child {
  margin: 0;
}

.content .other {
  padding: 0 15px;
}
.content .other .item {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f5f5f5;
}
.content .other .item:last-child {
  border: 0;
}
.content .other .item .name {
  margin-right: 10px;
  font-size: 14px;
  color: #333;
}
.content .other .item input {
  flex: 1;
  font-size: 14px;
  color: #666;
  text-align: right;
  outline: none;
}

.content .pic {
}
.content .pic .title {
  margin: 0 15px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f5f5f5;
}
.content .pic .title span {
  display: inline-block;
  float: left;
  font-size: 16px;
  color: #333;
}
.content .pic .title span.small {
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}
.content .pic .list {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  padding: 5px 10px;
}
.content .pic .list .img,
.content .pic .list .add {
  position: relative;
  width: 25%;
  padding-top: 25%;
}
.content .pic .list .img .close {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: #fff url("../../src/assets/icon-close.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 999px;
}
.content .pic .list .img span,
.content .pic .list .add span {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  padding: 5px;
  width: 100%;
  height: 100%;
}
.content .pic .list .img span img,
.content .pic .list .add span img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border: 1px solid #f5f5f5;
}
.submit {
  padding: 15px;
}
.submit button {
  background-color: #4cae4c;
}

.demo-upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}
.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
/*修改框架样式*/
/deep/ .cube-select-placeholder {
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/Communication.vue